// extracted by mini-css-extract-plugin
export default {"character-count":"ef272"};